import { Backdrop, CircularProgress, ThemeProvider, createTheme } from '@mui/material';

/**
 * @param props - open dialog
 * @returns - a dialog with loading animation.
 * @remarks This dialog is for showing a circular progress icon while the API is running for registering a user.
 */
export function LoadingDialog(props) {
    const { loading } = props

    const theme = createTheme({
        palette: {
            primary: {
                main: '#10AD61'
            },
            secondary: {
                main: '#10AD61'
            },
            background: {
                default: '#ffffff'
            },
        },
        typography: {
            h6: {
                color: '#484A57'
            },
            body1: {
                color: '#00000'
            }
        },
    });

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}
                >
                    <CircularProgress />
                </Backdrop>
            </ThemeProvider>
        </div >
    );
}